import React, { useCallback } from 'react';
import { Dropdown } from '@bynder/design-system';
import { IconCopy } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { ActionStatus, Entity, TemplateAction } from 'packages/hooks/useAccessRights/types';
import type { IsAvailable, Props } from './types';
import useAccessRights from 'packages/hooks/useAccessRights';

export const isDuplicateAvailable: IsAvailable = ({ isEntityActionAllowed, hiddenActions, template }) =>
    isEntityActionAllowed(TemplateAction.CREATE, Entity.TEMPLATE, template.grantedPermissions) !==
        ActionStatus.NOT_ALLOWED && !hiddenActions.includes('duplicateTemplate');

export const Duplicate = ({ template, menuActions }: Props) => {
    const { isEntityActionAllowed } = useAccessRights();
    const { translate } = useTranslate();

    const onClick = useCallback(() => menuActions.duplicateTemplate?.(template), [menuActions, template]);

    const isDisabled =
        isEntityActionAllowed(TemplateAction.CREATE, Entity.TEMPLATE, template.grantedPermissions) ===
        ActionStatus.DISABLED;

    return (
        <Dropdown.Item isDisabled={isDisabled} icon={<IconCopy />} onClick={onClick}>
            {translate('pages.categories.category.template.menu.duplicate')}
        </Dropdown.Item>
    );
};
